import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export class ContentNotPinnedToSectionError extends CodedError {
  static get errorName() {
    return errorCodes.contentNotPinnedToSectionError.code;
  }

  constructor(message: string = errorCodes.contentNotPinnedToSectionError.message) {
    super(message);
    this.code = errorCodes.contentNotPinnedToSectionError.code;
    this.message = `${message} ${errorCodes.contentNotPinnedToSectionError.code}`;
    this.name = errorCodes.contentNotPinnedToSectionError.name;
  }
}
